import {FC} from 'react';

import {ReportForma} from '../../components/Reports/report/ReportForma';

const FormaPage: FC = () => {
  return (
    <div>
      <ReportForma />
    </div>
  );
};

export default FormaPage;
